/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_INVOICE =
  'GET_CURRENT_DISPLAY_OBJ_INVOICE';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_INVOICE =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_INVOICE';
export const REFRESH_PREINVOICE_UNIT_ADJUSTMENT =
  'REFRESH_PREINVOICE_UNIT_ADJUSTMENT';
export const REFRESH_PREINVOICE_UNIT_ADJUSTMENT_DISPLAY =
  'REFRESH_PREINVOICE_UNIT_ADJUSTMENT_DISPLAY';
export const GET_PLAN_TYPE_DATA_INVOICE = 'GET_PLAN_TYPE_DATA_INVOICE';
export const GET_REBATE_PROGRAM_INVOICE = 'GET_REBATE_PROGRAM_INVOICE';
export const GET_REBATE_PROGRAM_NAME_INVOICE =
  'GET_REBATE_PROGRAM_NAME_INVOICE';
export const GET_ERROR_MSG_INVOICE = 'GET_ERROR_MSG_INVOICE';
export const GET_QUARTER_INVOICE = 'GET_QUARTER_INVOICE';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SET_DISPLAY_OBJ_INVOICE = 'SET_DISPLAY_OBJ_INVOICE';
export const SELECT_REPORT_OPTION = 'SELECT_REPORT_OPTION';
export const SET_DATE_RANGE_INVOICE = 'SET_DATE_RANGE_INVOICE';
export const GET_PRE_INVOICE_SUMMARY = 'GET_PRE_INVOICE_SUMMARY';
export const GET_PRE_INVOICE_DETAIL = 'GET_PRE_INVOICE_DETAIL';
